import {app} from '../../app';
import IScope = angular.IScope;
import {ISessionService} from "../../services/SessionService";
import IComponentController = angular.IComponentController;

export class TextQuestionPreviewComponent {

    protected sessionService:ISessionService;

    question:IQuestion;
    value:string;

    static $inject = ['SessionService'];

    constructor(sessionService:ISessionService) {

        this.sessionService = sessionService;

    }

    public $onInit = () => {
        this.setup();
    };

    setup() {
        let answer = this.sessionService.getAnswer(this.question.id);
        if (answer && answer.values.length > 0 && answer.values[0] !== null) {
            this.value = answer.values[0].value;
        }
    }

}

app.component('textQuestionPreview', {
    templateUrl : 'templates/components/questionPreviews/textQuestionPreview.html',
    controller  : TextQuestionPreviewComponent,
    controllerAs: 'textQuestionPreview',
    bindings    : {
        question: '<'
    }
});